module.exports = __webpack_public_path__ + "img/j2.7cbad20f.png";